export const burger = [
  {
    id: "1",
    name: "Zinger Burger",
    burgerPrice: "350",
    mealPrice: "470",
  },
  {
    id: "2",
    name: "Zinger Cheese Burger",
    burgerPrice: "400",
    mealPrice: "520",
  },
  {
    id: "3",
    name: "Pizza Burger",
    burgerPrice: "480",
    mealPrice: "500",
  },
  {
    id: "4",
    name: "Tower Burger",
    burgerPrice: "550",
    mealPrice: "670",
  },
  {
    id: "5",
    name: "Zinger Tower Burger",
    burgerPrice: "550",
    mealPrice: "670",
  },
  {
    id: "6",
    name: "Chapli Burger",
    burgerPrice: "250",
    mealPrice: "370",
  },
  {
    id: "7",
    name: "Crunch Burger",
    burgerPrice: "250",
    mealPrice: "370",
  },
];
